import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const customerContactTypesAdapter = getAdapter();

const customerContactTypesSlice = createSlice({
  name: 'customerContactTypes',
  initialState: customerContactTypesAdapter.getInitialState(),
  reducers: {
    setCustomerContactTypes: (state, { payload: { customerContactTypes } }) => {
      customerContactTypesAdapter.setAll(state, customerContactTypes);
    },
  },
});

const selectors = customerContactTypesAdapter.getSelectors(({ customerContactTypes }) => customerContactTypes);

export const getCustomerContactTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getCustomerContactTypes = (state) => getCustomerContactTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
   setCustomerContactTypes,
} = customerContactTypesSlice.actions;

export default customerContactTypesSlice.reducer;